import { api, apiGet } from "../api";

export async function listFormsForBooking(bookingId) {
  return apiGet(`/forms/booking/${bookingId}`);
}

export async function getFormDraft(bookingId, formId) {
  return apiGet(`/forms/booking/${bookingId}/responses/${formId}`);
}

export async function submitFormResponse(bookingId, payload) {
  return api(`/forms/booking/${bookingId}/responses`, payload);
}

export async function skipForm(bookingId, payload) {
  return api(`/forms/booking/${bookingId}/skip`, payload);
}

// Email questions flagged `requireVerification` gate submission behind a
// 6-digit code: send mails it (60s resend cooldown, 10 min expiry),
// confirm exchanges it for a verified address the submit endpoint accepts.
export async function sendFormEmailVerification(bookingId, payload) {
  return api(`/forms/booking/${bookingId}/verify-email/send`, payload);
}

export async function confirmFormEmailVerification(bookingId, payload) {
  return api(`/forms/booking/${bookingId}/verify-email/confirm`, payload);
}
